<template>
  <div
    v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('view_apartment_receipt')"
    style="border: 0px solid black; width:100%;"
  >
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-success">
          <div class="box-header with-border">
            <h3 class="box-title">{{ $t("search.title") }}</h3>
          </div>
          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-3 col-md-3 col-lg-3">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('search.title')"
                  v-model="search.searchText"
                />
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar">
                        <label>
                          <span style="margin-left:5px;display:inline-block;"
                            >{{ $t("service_history.date_from") }}:</span
                          >
                        </label>
                      </i>
                    </div>
                    <date-picker
                      :config="options"
                      v-model="search.startTime"
                      @dp-change="onChangeStartTime(search.startTime)"
                    ></date-picker>
                  </div>
                </div>
              </div>

              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar">
                        <label>
                          <span style="margin-left:5px;display:inline-block;"
                            >{{ $t("service_history.date_to") }}:</span
                          >
                        </label>
                      </i>
                    </div>
                    <date-picker
                      :config="endDateOptions"
                      v-model="search.endTime"
                    ></date-picker>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <button
                  type="button"
                  class="btn btn-labeled btn-success pull-right"
                  @click="onSearchCase"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{ $t("search.search_button") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <!--  -->
        <div class="box box-primary">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <!-- <b>{{ $t("apartmentType.title") }}</b> -->
              <!-- <lte-button
                style="float:right"
                type="btn btn-primary"
                right_icon="fa fa-plus"
                v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('create_apartment')"
                @click="addNew($event)"
                >{{ $t("common.addnew") }}</lte-button
              > -->
            </div>
          </div>
          <div class="box-body">
            <!-- B-Table Start -->
            <b-table
              :items="gridDataList"
              :fields="gridColumns"
              class="mt-3"
              outlined
              responsive
            >
              <template #head()="scope">
                <div>{{ $t(scope.label) }}</div>
              </template>
              <template #cell(totalFee)="row">
                <div>{{ currencyFormat(row.item.totalFee) }}</div>
              </template>
              <template #cell(roomCharge)="row">
                <div>{{ currencyFormat(row.item.roomCharge) }}</div>
              </template>
              <template #cell(serviceFee)="row">
                <div>{{ currencyFormat(row.item.serviceFee) }}</div>
              </template>
              <template #cell(productFee)="row">
                <div>{{ currencyFormat(row.item.productFee) }}</div>
              </template>
            </b-table>
            <!-- B-Table End -->
          </div>
        </div>
        <!--  -->
        <div class="box-footer clearfix" style="display:contents;">
          <paginator
            :totalItem="paginateData.totalItem"
            :currentPage="paginateData.currentPage"
            :pageSize="paginateData.pageSize"
            :totalPage="paginateData.totalPage"
            @onpaginate="onPagination"
          />
        </div>
        <!-- <lte-modal
          v-show="isModalVisible"
          @onConfirm="onConfirm"
          @close="closeModal"
          v-for="obj in objModal"
          :key="obj.id"
          :item="obj"
        ></lte-modal> -->
        <lte-core-alert
          v-for="snackbar in GET_SNACK_BAR"
          :key="snackbar.id"
          :item="snackbar"
        ></lte-core-alert>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF"
        ></loading>
      </row>
    </div>
  </div>
</template>
<script>
import Paginator from "@/components/CustomPaginator.vue";
import { mapGetters, mapActions } from "vuex";
// import LTEButton from "@/components/LTEButton.vue";
// import LTEModal from "@/components/LTEModal.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import utils from '@/lib/utils';
import datePicker from "vue-bootstrap-datetimepicker";
import Loading from "vue-loading-overlay";
import moment from "moment";

export default {
  components: {
    // "lte-button": LTEButton,
    // "lte-modal": LTEModal,
    "date-picker": datePicker,
    "lte-core-alert": LTECoreAlert,
    paginator: Paginator,
    loading: Loading
  },
  data() {
    return {
      search: {
        searchText: null,
        startTime: null,
        endTime: null,
        apartmentTypeId: null
      },
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false
      },
      endDateOptions: {
        format: "DD/MM/YYYY",
        useCurrent: false,
        minDate: moment()
      },
      // 
      gridDataList: [],
      gridColumns: [
        {
          label: "common.nonumber",
          key: "nonumber",
          class: "text-center"
        },
        {
          label: "apartmentReceipt.invoiceCode",
          key: "invoiceCode",
        },
        {
          label: "apartmentReceipt.customer",
          key: "customer",
        },
        {
          label: "apartment.apartmentName",
          key: "apartmentName",
        },
        {
          label: "apartmentReceipt.dateCreated",
          key: "dateCreated",
        },
        // {
        //   label: "apartmentReceipt.reserve",
        //   key: "reserve",
        //   class: "text-center"
        // },
        {
          label: "apartmentReceipt.productFee",
          key: "productFee",
          class: "text-right"
        },
        {
          label: "apartmentReceipt.serviceFee",
          key: "serviceFee",
          class: "text-right"
        },
        {
          label: "apartmentReceipt.roomCharge",
          key: "roomCharge",
          class: "text-right"
        },
        // {
        //   label: "apartmentReceipt.surcharge",
        //   key: "surcharge",
        //   class: "text-right"
        // },
        // {
        //   label: "apartmentReceipt.discount",
        //   key: "discount",
        //   class: "text-right"
        // },
        // {
        //   label: "apartmentReceipt.vat",
        //   key: "vat",
        //   class: "text-right"
        // },
        {
          label: "apartmentReceipt.totalFee",
          key: "totalFee",
          class: "text-right"
        }
      ],
      originalRecordData: [],
      isModalVisible: false,
      objModal: [
        {
          title: "common.delete_modal.title",
          body: "common.delete_modal.content",
          buttonNo: "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ],
      isLoading: false,
      paginateData: {
        totalItem: 1,
        currentPage: 1,
        pageSize: 1,
        totalPage: 1
      }
    };
  },
  watch: {
    GET_APARTMENT_RECEIPT_INVOICE_REVENUE_LIST_DATA: function() {
      let paginate = this.GET_APARTMENT_RECEIPT_INVOICE_REVENUE_LIST_DATA
        .paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      this.gridDataList = [];
      let data = this.GET_APARTMENT_RECEIPT_INVOICE_REVENUE_LIST_DATA.results;

      data.forEach((element, i) => {
        let id = element.id;
        let nonumber = i + 1 + (paginate.currentPage - 1) * paginate.pageSize;

        let data = {
          id: id,
          nonumber: nonumber,
          invoiceCode: element.code,
          customer: element.user_in_booking_data.full_name,
          apartmentName: !utils.isEmptyString(element.apartment_data.name)
            ? element.apartment_data.name : element.apartment_data.code,
          dateCreated: utils.formatSqlDate(element.date_created, null, "HH:mm DD/MM/YYYY"),
          serviceFee: element.service_total_fee,
          productFee: element.product_total_fee,
          roomCharge: element.room_charge,
          totalFee: element.total_fee
        };
        this.gridDataList.push(data);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA",
      "GET_APARTMENT_RECEIPT_INVOICE_REVENUE_LIST_DATA"
    ])
  },

  methods: {
    onChangeStartTime: function(data) {
      if (!utils.isEmptyString(data)) {
        this.endDateOptions.minDate = moment(data, "DD/MM/YYYY")
      }
      this.search.endTime = null
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    currencyFormat: function(value) {
      if (!utils.isEmptyString(value)) {
        return utils.formatNumber(value);
      }
      return null;
    },
    getSearchData: function(data) {
      this.search.searchText = data.searchText;
      this.search.startTime = data.startTime;
      this.search.endTime = data.endTime;
      this.getApartmentReceiptList(1);
    },
    onSearchCase: function() {
      this.getApartmentReceiptList(1);
    },
    onConfirm: function() {
      this.isModalVisible = false;
      this.DELETE_APARTMENT_TYPE(this.originalRecordData)
        .then(
          function() {
            this.getApartmentReceiptList(this.paginateData.currentPage);
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    onPagination: function(data) {
      this.getApartmentReceiptList(data);
    },
    closeModal() {
      this.isModalVisible = false;
    },
    getApartmentReceiptList: function(page) {
      this.isLoading = true;
      let filter = {
        params: {
          page: page,
          searchText: this.search.searchText,
          startTime: utils.formatSqlUtcDate(this.search.startTime, "DD/MM/YYYY", "YYYY-MM-DD HH:mm"),
          endTime: utils.formatSqlUtcDate(this.search.endTime, "DD/MM/YYYY", "YYYY-MM-DD HH:mm"),
          type: 1
        }
      };
      this.GET_APARTMENT_RECEIPT_INVOICE_REVENUE_LIST(filter)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    onGetData: function() {
      this.getApartmentReceiptList(this.paginateData.currentPage);
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "DELETE_APARTMENT_TYPE",
      "GET_APARTMENT_RECEIPT_INVOICE_REVENUE_LIST"
    ])
  },
  mounted() {
    this.getApartmentReceiptList(1);
  }
};
</script>
<style scoped>
label.required:after {
  content: " *";
  color: red;
  position: absolute;
  padding-left: 8px;
  top: -5px;
}

.apartment-type-class {
  margin: auto;
  width: 100%;
  max-width: 200px;
  max-height: 250px;
  object-fit: contain;
  padding: 5px;
}

.apartment-img-block {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/views/ApartmentBooking/RoomBill.vue